import { createContext } from 'react';
import { getParamsDefault } from 'config/params';

export const ParamsContext = createContext(getParamsDefault());
ParamsContext.displayName = 'ParamsContext';
